const MusicCardSkeleton = () => {
  return (
    <div>
      <div className="w-[180px] h-[300px] bg-[#1a1919] animate-pulse mt-2"></div>
    </div>
  );
};

export default MusicCardSkeleton;
